import { GetProductsPageDataResponseSchema, type GetProductsPageDataResponse } from '@weft/api-definition';
import { isEmptyString, purge, withDefault } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomBaseUseQueryOptions } from '../requests-types/custom-use-query-options';

type UseProductsPagePayload = Parameters<ReturnType<typeof getPrivateApi>['getProductsPageData']>[0];

export function useProductsPage(payload: UseProductsPagePayload = {}, options?: CustomBaseUseQueryOptions<GetProductsPageDataResponse>) {
  return useQuery(['products-page', ...purge(Object.values(payload))], async () => {
    const api = getPrivateApi();
    const productsDataResponse = await api.getProductsPageData({
      search: isEmptyString(payload.search) ? undefined : payload.search,
      pageSize: withDefault(payload.pageSize, 100),
      page: withDefault(payload.page, 0),
    });

    return GetProductsPageDataResponseSchema.parse(productsDataResponse);
  }, { ...options });
}